import { render } from "./AdminUsefulLinks.vue?vue&type=template&id=7e5b579a&scoped=true&ts=true"
import script from "./AdminUsefulLinks.vue?vue&type=script&lang=ts"
export * from "./AdminUsefulLinks.vue?vue&type=script&lang=ts"

import "./AdminUsefulLinks.vue?vue&type=style&index=0&id=7e5b579a&scoped=true&lang=css"
import "./AdminUsefulLinks.vue?vue&type=style&index=1&id=7e5b579a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e5b579a"]])

export default __exports__